import { Navigate, useLocation } from "react-router-dom";
import {
  getAppId,
  getAppType,
  getDeclarationInfo,
  getEmailInfo,
  getPageInfo,
  getQrVerificationInfo,
  getStageID,
} from "./Common";

const statusStages = new Set([
  130, 140, 150, 160, 300, 500, 510, 520, 530, 540, 550, 600, 610, 620,
  1000,
]);

const routeStages = {
  "/anuani_ya_sasa": new Set([100, 110]),
  "/taarifa_za_safari": new Set([110, 120]),
  "/selfDeclaration": new Set([120]),
  "/stp1": new Set([210, 220]),
  "/stp1B": new Set([210, 220]),
  "/stp2": new Set([220, 230]),
  "/stp3": new Set([230, 240]),
  "/stp4": new Set([240, 250]),
  "/stp5": new Set([250, 260]),
  "/stp6": new Set([260, 270]),
  "/stp7": new Set([270]),
};

const hasData = (value) =>
  value && typeof value === "object" && Object.keys(value).length > 0;

const safeRead = (reader, fallback = null) => {
  try {
    return reader() ?? fallback;
  } catch (_error) {
    return fallback;
  }
};

const isRouteAllowed = (path) => {
  if (path === "/" || path === "/continue") return true;

  if (path === "/emailverification") {
    return hasData(safeRead(getPageInfo, {}));
  }

  if (path === "/docmentVerification" || path === "/upload-photo") {
    return hasData(safeRead(getEmailInfo, {}));
  }

  if (path === "/qrverification") {
    return hasData(safeRead(getQrVerificationInfo, {}));
  }

  const appId = safeRead(getAppId);
  if (!appId) return false;

  if (path === "/application") return true;

  const stage = Number(safeRead(getStageID));
  if (!Number.isFinite(stage)) return false;

  if (path === "/stp10") return statusStages.has(stage);
  if (path === "/billInfo") return stage > 140 && statusStages.has(stage);

  if (path === "/selfDeclaration" && !hasData(safeRead(getDeclarationInfo, {}))) {
    return false;
  }

  const allowedStages = routeStages[path];
  if (!allowedStages?.has(stage)) return false;

  // Stage 210 has two different personal-information forms. Ensure a URL edit
  // cannot switch an applicant into the other application's form.
  const appType = Number(safeRead(getAppType));
  if (path === "/stp1B") return appType === 3;
  if (path === "/stp1") return appType === 4 || appType === 5;

  return true;
};

const ProtectedRoute = ({ element }) => {
  const location = useLocation();

  if (!isRouteAllowed(location.pathname)) {
    return <Navigate to="/" replace state={{ accessDenied: true }} />;
  }

  return element;
};

export default ProtectedRoute;
